import { gql } from 'graphql-request';

/**
 * GetConfig query — served by the config service, not in the main schema.
 * Shared constant to avoid duplication across main.tsx and useOnboardingConfig.ts.
 * TODO: Add to schema.graphql and codegen once config service is federated.
 */
export const GET_CONFIG_QUERY = gql`
  query GetConfig($configKey: String!) {
    getConfig(configKey: $configKey) {
      key
      version
      type
      data
      is_active
    }
  }
`;

export interface GetConfigResult {
  getConfig: {
    key: string;
    version: number;
    type: string;
    data: Record<string, unknown>;
    is_active: boolean;
  } | null;
}
